import { GroupBase, OptionsOrGroups, OptionTypeBase } from '@cad-arc';
export type Option<T extends string | number = number> = {
    label: string;
    value: T;
};

export type OptionOrOptions = OptionTypeBase | OptionTypeBase[];

export type SelectOptions = OptionsOrGroups<OptionTypeBase, GroupBase<OptionTypeBase>>;

/**
 * We use this option as a global "OTHER" option because we don't actually have "other"
 * attributes for all vehicle make and models
 */
export const OTHER_OPTION = {
    label: 'Other',
    value: -1,
    isOther: true,
};
